import { render } from "./EnsinoPorEscola.vue?vue&type=template&id=9e4c8dba&scoped=true&ts=true"
import script from "./EnsinoPorEscola.vue?vue&type=script&lang=ts"
export * from "./EnsinoPorEscola.vue?vue&type=script&lang=ts"

import "./EnsinoPorEscola.vue?vue&type=style&index=0&id=9e4c8dba&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e4c8dba"],['__file',"src/components/Ensino/EnsinoPorEscola.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e4c8dba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e4c8dba', __exports__)) {
    api.reload('9e4c8dba', __exports__)
  }
  
  module.hot.accept("./EnsinoPorEscola.vue?vue&type=template&id=9e4c8dba&scoped=true&ts=true", () => {
    api.rerender('9e4c8dba', render)
  })

}


export default __exports__